import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  GuestFlightScheduleLiteModel,
  GuestHotelScheduleLiteModel,
  MassUpdateFlightScheduleMutationInput,
  MassUpdateHotelScheduleMutationInput,
} from './model';

const ENDPOINT = 'cro' as const;

export function useUpdateFlightSchedule(
  options?: UseMutationOptions<
    ApiResult<GuestFlightScheduleLiteModel[]>,
    ApiError,
    MassUpdateFlightScheduleMutationInput
  >,
): UseMutationResult<
  ApiResult<GuestFlightScheduleLiteModel[]>,
  ApiError,
  MassUpdateFlightScheduleMutationInput
> {
  return useMutation<
    ApiResult<GuestFlightScheduleLiteModel[]>,
    ApiError,
    MassUpdateFlightScheduleMutationInput
  >(async function (body) {
    return MutationFetchFunction({
      method: 'PUT',
      url: `${ENDPOINT}/mass-update-flight-schedules`,
      body,
      classType: GuestFlightScheduleLiteModel,
    });
  }, options);
}

export function useUpdateHotelSchedule(
  options?: UseMutationOptions<
    ApiResult<GuestHotelScheduleLiteModel[]>,
    ApiError,
    MassUpdateHotelScheduleMutationInput
  >,
): UseMutationResult<
  ApiResult<GuestHotelScheduleLiteModel[]>,
  ApiError,
  MassUpdateHotelScheduleMutationInput
> {
  return useMutation<
    ApiResult<GuestHotelScheduleLiteModel[]>,
    ApiError,
    MassUpdateHotelScheduleMutationInput
  >(async function (body) {
    return MutationFetchFunction({
      method: 'PUT',
      url: `${ENDPOINT}/mass-update-hotel-schedules`,
      body,
      classType: GuestHotelScheduleLiteModel,
    });
  }, options);
}
